export const colors = {
  foreground: '#252A34',
  foregroundLight: '#3D4451',
  primary: '#FF2E63',
  primaryLight: '#FF668B',
  primaryDark: '#A82047',
  primaryDarkLight: '#D14D72',
  accent: '#08D9D6',
  accentLight: '#6AEBE9',
  card: '#FFFFFF',
  border: '#DADADA',
  white: '#FFFFFF',
  pageGradientFrom: '#EAEAEA',
  pageGradientTo: '#FFFFFF',
};

export const fonts = {
  raleway: "'Raleway', sans-serif",
  baloo: "'Baloo 2', sans-serif",
};

export const weights = {
  normal: 400,
  medium: 500,
  semibold: 600,
  bold: 700,
  extrabold: 800,
  black: 900,
};

export const layout = {
  maxWidth: '1280px',
  headerHeight: '80px',
  cardMinWidth: '260px',
  cardMaxWidth: '300px',
};

export const shadows = {
  header: '0px 2px 8px rgba(0, 0, 0, 0.06)',
  card: '0px 4px 20px rgba(37, 42, 52, 0.12)',
  cardHover: '0px 8px 28px rgba(255, 46, 99, 0.15)',
  icon: '0px 2px 8px rgba(0, 0, 0, 0.1)',
};

export const breakpoints = {
  md: '768px',
  lg: '1024px',
};